
    import './styles.scoped.css';
    export default {
  "root": "awsui_root_gxp9y_1ixpm_181",
  "list": "awsui_list_gxp9y_1ixpm_212",
  "container": "awsui_container_gxp9y_1ixpm_217",
  "header": "awsui_header_gxp9y_1ixpm_222",
  "details": "awsui_details_gxp9y_1ixpm_226",
  "connector": "awsui_connector_gxp9y_1ixpm_232"
};
  